<template>
  <div>
    <CDropdownDivider v-if="showDivider" />
    <div class="p-2">
      <CRow>
        <CCol class="pt-2 pb-1">
          <strong class="mb-0">{{ grainWanted.grainLabel }}</strong>
          <span v-if="grainWanted.grade"> | {{ grainWanted.gradeLabel }}</span>
        </CCol>
        <CCol col=2>
          <div class="float-right" style="position: relative; top: -8px;">
            <CBadge class="mt-3" color="danger">WANTED</CBadge>
          </div>
        </CCol>
      </CRow>
      <CRow class="mt-2">
        <CCol class="pl-2 pb-0">
          <ul class="pl-4 mb-0">
            <li v-if="grainWanted.location">{{ grainWanted.location }}</li>
            <li v-if="grainWanted.storageType">{{ grainWanted.storageTypeLabel }}</li>
            <li v-if="grainWanted.offerType">{{ grainWanted.offerTypeLabel }}</li>
            <li v-if="grainWanted.priceMax">Up to {{ grainWanted.priceLabel }} / mt</li>
            <li v-if="grainWanted.dateCreated">Posted {{ grainWanted.dateCreatedDateOnlyFormatted }}</li>
          </ul>
          <div class="m-2" v-if="grainWanted.comment">
            &ldquo;<i>{{ grainWanted.comment }}</i>&rdquo;
          </div>
          <div class="m-2 mt-3">
            <CButton 
              class="mr-2"
              size="sm" 
              color="primary"
              variant="outline"
              @click.stop="search()"
            >
              Search
            </CButton>
            <CButton
              size="sm" 
              color="primary"
              variant="outline"
              @click.stop="createOffer()"
            >
              Create offer
            </CButton>
          </div>
        </CCol>
        <CCol v-if="isAdminUser" col=12 sm=6>
          <AdminOwner :entity="grainWanted" entityType="Grain Wanted" class="mb-1" />
      </CCol>
      </CRow>

    </div>
  </div>
</template>

<script>
import GrainWanted from '@/model/grain-wanted'
import { apiSearchToFilterSearch } from '@/views/search/search.js'
import AdminOwner from '@/views/components/AdminOwner'

export default {
  name: 'GrainWantedCard',
  components: {
    AdminOwner
  },
  props: {
    grainWanted: GrainWanted,
    showDivider: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isAdminUser () {
      return this.$store.getters['auth/isAdminUser']
    },
  },
  methods: {
    createOffer () {
      return this.$router.push({ name: 'Offer flow grain', params: {grainWanted: this.grainWanted} })
    },
    search () {
      const filterSearch = apiSearchToFilterSearch(this.grainWanted)
      return this.$router.push({ name: 'Search', params: {search: filterSearch} })
    },
  }
}
</script>
